<script setup lang="ts">
const props = defineProps<{
  resourceId: number
  resourceType: ResourceType
  likeStatus: LikeStatus
  type: 'like' | 'dislike'
  vertical?: boolean
}>()
const status = ref(props.likeStatus)
const $toast = useToast()
async function handleClick() {
  const { data: userInfo } = useAuth()
  if (!userInfo.value.login) {
    useEmitter().emit('requestLogin')
    return
  }
  if (props.likeStatus[props.type].is_active) {
    // 取消
    const res = await requestCancelLikeResource(
      props.resourceId,
      props.resourceType
    )
    if (res.code === 1) {
      $toast.info('已取消')
      status.value[props.type].is_active = false
      status.value[props.type].count--
    } else {
      $toast.error(res.msg)
    }
  } else {
    // 喜欢
    const res =
      props.type === 'dislike'
        ? await requestDislikeResource(props.resourceId, props.resourceType)
        : await requestLikeResource(props.resourceId, props.resourceType)
    if (res.code === 1) {
      const message =
        props.type === 'dislike' ? '已点踩' : '已点赞，感谢您的支持'
      $toast.success(message)
      status.value[props.type].is_active = true
      status.value[props.type].count++
      if (props.type === 'dislike' && status.value.like.is_active) {
        status.value.like.is_active = false
        status.value.like.count--
      } else if (props.type === 'like' && status.value.dislike.is_active) {
        status.value.dislike.is_active = false
        status.value.dislike.count--
      }
    } else {
      $toast.error(res.msg)
    }
  }
}
</script>

<template>
  <m-icon
    class="m-like-action pointer"
    :vertical="vertical"
    :icon="type === 'like' ? 'lucide-thumbs-up' : 'lucide-thumbs-down'"
    :class="{
      active: status[type].is_active
    }"
    @click="handleClick"
  >
    <slot />
  </m-icon>
</template>
